import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface ClothingMarkerModalResult {
  markerCode: string;
  markerType: string;
}

@Component({
  selector: 'app-clothing-marker-modal',
  templateUrl: './clothing-marker-modal.component.html',
  styleUrls: ['./clothing-marker-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingMarkerModalComponent {
  markerCode = '';
  isPersonalMarker = false;

  constructor(public activeModal: NgbActiveModal) {}

  togglePersonalMarker() {
    this.isPersonalMarker = !this.isPersonalMarker;
  }

  save() {
    if (!this.canSave()) {
      return;
    }
    this.activeModal.close(this.createResult());
  }

  cancel() {
    this.activeModal.dismiss();
  }

  canSave(): boolean {
    return this.normalizeMarkerCode().length > 0;
  }

  private createResult(): ClothingMarkerModalResult {
    return {
      markerCode: this.normalizeMarkerCode(),
      markerType: this.resolveMarkerType()
    };
  }

  private resolveMarkerType(): string {
    if (this.isPersonalMarker) {
      return 'JOB';
    }
    return 'DEPARTMENT';
  }

  private normalizeMarkerCode(): string {
    if (!this.markerCode) {
      return '';
    }
    return this.markerCode.trim();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-marker-modal.component.ts